import { Box, Grid, Stack, Typography, styled } from '@mui/material'
import VisitLogCount from './VisitLogCount'
import OngoingLogs from './Ongoing';
import CompletedLogs from './CompletedLogs';
import OngoingTableLog from './OngoingTableLog';
import { useEffect, useState } from 'react';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';

const BoxContainer = styled(Box)`
    display:flex;
    flex-direction:column;
`;

interface VisitCountProps {
    totalCount: number;
    ongoingCount: number;
    completedCount: number;
}

const Visitlogs = () => {
    const [visitCount, setVisitCount] = useState<VisitCountProps>({ totalCount: 0, ongoingCount: 0, completedCount: 0 });
    const [ongoingVisits, setOngoingVisits] = useState<Array<any>>([]);
    const [completedVisits, setCompletedVisits] = useState<Array<any>>([]);
    const [loading, setLoading] = useState<string | null>(null);
    const [count, setCount] = useState<any>();

    const { get } = useCrudForm();

    const fetchVisitCount = () => {
        get({
            endpoints: endpoints.visitLogs.visitCount,
            onSuccess: (data: any) => {
                setVisitCount(data.data);
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    const fetchOngoingVisits = (skip?: any, take?: any) => {
        get({
            endpoints: `${endpoints.visitLogs.ongoing}?skip=${skip * take}&take=${take}`,
            onSuccess: (data: any) => {
                setOngoingVisits(data.data.list);

                setCount((prev: any) => {
                    return { ...prev, ongoing: data.data.count }
                })
                setLoading(null)
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(null)
            }
        })
    }

    const fetchCompletedVisits = (skip?: any, take?: any) => {
        get({
            endpoints: `${endpoints.visitLogs.completed}?skip=${skip * take}&take=${take}`,
            onSuccess: (data: any) => {
                setCompletedVisits(data.data.list);
                setCount((prev: any) => {
                    return { ...prev, completed: data.data.count }
                })
                setLoading(null)
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(null)
            }
        })
    }

    const refetch = (skip?: any, take?: any) => {
        fetchVisitCount();
        fetchCompletedVisits(skip ?? 0, take ?? 10);
        fetchOngoingVisits(skip ?? 0, take ?? 10);
    }

    useEffect(() => {
        refetch(0, 10)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>Visits Log</Typography>
            <Stack>
                <VisitLogCount visitCount={visitCount} refetch={refetch} />
            </Stack>
            <Grid container spacing={2} paddingTop={2}>
                <Grid item xs={6}>
                    <Stack direction={'column'} spacing={2} sx={{ backgroundColor: 'white', borderRadius: '5px', padding: '20px' }}>
                        <BoxContainer>
                            <OngoingLogs />
                            <OngoingTableLog count={count?.ongoing} ongoingVisits={ongoingVisits} refetch={refetch} fetchOngoingVisits={fetchOngoingVisits} setLoading={setLoading} loading={loading} />
                        </BoxContainer>
                    </Stack>

                </Grid>
                <Grid item xs={6}>
                    <Stack direction={'column'} spacing={4} sx={{ backgroundColor: 'white', borderRadius: '5px', padding: '20px' }}>
                        <CompletedLogs count={count?.completed} completedVisits={completedVisits} fetchCompletedVisits={fetchCompletedVisits} setLoading={setLoading} loading={loading} />
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Visitlogs
